import HttpClient from 'services/HttpClient'
import {
  AIUsageLogDto,
  AIUsageLogPreviewDto,
  AIUsageLogsParams,
  AIUsageLogsResponse,
  AIUsageStatisticsResponse} from 'types/aiAnalytics'

export class AiUsageLogsRepository {
  api: typeof HttpClient

  constructor(api: typeof HttpClient) {
    this.api = api
  }

  getUsageLogs(
    params: AIUsageLogsParams
  ): Promise<{ data: AIUsageLogsResponse }> {
    const queryParams = new URLSearchParams()

    // Pagination
    if (params.limit) {
      queryParams.append('limit[take]', params.limit.take.toString())
      queryParams.append('limit[page]', params.limit.page.toString())
    }

    // Sorting
    if (params.order) {
      queryParams.append('order[by]', params.order.by)
      queryParams.append('order[dir]', params.order.dir)
    }

    // Filters - add only if they exist and are not empty strings
    const filters = {
      userId: params.userId,
      brandId: params.brandId,
      countryCode: params.countryCode,
      operationType: params.operationType,
      resourceId: params.resourceId,
      status: params.status,
      startDate: params.startDate,
      endDate: params.endDate,
      search: params.search
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== '') {
        queryParams.append(key, value)
      }
    })

    return this.api.get(`/ai-usage-logs?${queryParams.toString()}`)
  }

  getStatistics(
    params: Partial<AIUsageLogsParams>
  ): Promise<{ data: AIUsageStatisticsResponse }> {
    const queryParams = new URLSearchParams()

    const filters = {
      userId: params.userId,
      brandId: params.brandId,
      countryCode: params.countryCode,
      operationType: params.operationType,
      startDate: params.startDate,
      endDate: params.endDate
    }

    Object.entries(filters).forEach(([key, value]) => {
      // Only add filter if it has a value and is not an empty string
      if (value && value !== '') {
        queryParams.append(key, value)
      }
    })

    return this.api.get(`/ai-usage-logs/statistics?${queryParams.toString()}`)
  }

  getUsageLogById(id: string): Promise<{ data: AIUsageLogDto }> {
    return this.api.get(`/ai-usage-logs/${id}`)
  }

  getUsageLogPreview(id: string): Promise<{ data: AIUsageLogPreviewDto }> {
    return this.api.get(`/ai-usage-logs/${id}/preview`)
  }
}

export default new AiUsageLogsRepository(HttpClient)
